import { render, staticRenderFns } from "./PropertyDetailsForm.vue?vue&type=template&id=451a5dce&scoped=true&"
import script from "./PropertyDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a5dce",
  null
  
)

export default component.exports